module.exports = __webpack_public_path__ + "img/logo4.0f661acf.png";